import Customers from "./components/Customers";

export default Customers;
